import React from 'react';
export function HookSection() {
  return <section className="w-full bg-ink-900 py-16 sm:py-20" aria-labelledby="gancho-title" data-id="element-67" data-mp="27fq7tm4my48m">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-68" data-mp="7huavdrul154">
        <h2 id="gancho-title" className="font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-69" data-mp="m7rurhiqv4oi">
          ¿Sentís un{' '}
          <span className="text-amber-brand" data-id="element-70" data-mp="3pnyytp52n3xt">&ldquo;ruidito&rdquo;</span> nuevo y
          se te acelera el corazón pensando en cuánto te va a costar?
        </h2>

        <div className="mt-7 space-y-5 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-71" data-mp="3kqgnjs3l0cmn">
          <p data-id="element-72" data-mp="2ku6d7anc6g4">
            Entrar a un taller mecánico en Argentina hoy es como entrar a un
            casino: sabés cuánta plata llevás, pero no tenés idea de cuánta vas
            a dejar. Los repuestos suben todas las semanas y la
            &ldquo;ignorancia mecánica&rdquo; es el negocio de muchos.
          </p>
          <p data-id="element-73" data-mp="19yxa7vkrvuya">
            No saber nada de autos te sale caro. Te sale caro cuando te cobran
            un repuesto que no cambiaron, cuando te inventan una fuga de aceite
            o cuando ignorás una luz del tablero y terminás fundiendo el motor
            en la autopista.
          </p>
        </div>

        <p className="mt-8 border-l-4 border-amber-brand pl-5 font-display text-2xl font-bold uppercase text-white sm:text-3xl" data-id="element-74" data-mp="3pztiqhdpaf0x">
          Es hora de equilibrar la balanza.
        </p>
      </div>
    </section>;
}